import moment from "moment";
window.moment = moment;
export const createMonthList = vdate => {
  const date = moment(vdate);
  const nextMonth = date.clone().add(1, "month"); // den ngày này
  return [date, nextMonth];
};

export const renderCalendar = vdate => {
  const date = moment(vdate);
  const days = [];

  const firstDate = date
    .clone()
    .startOf("month")
    .startOf("week")
    .subtract(1);

  const lastDate = date
    .clone()
    .endOf("month")
    .endOf("week");

  const length = lastDate.diff(firstDate, "days");
  for (let i = 0; i < length; i++) {
    days.push(firstDate.clone().add(i, "day"));
  }
  return days;
};

export const renderDaysInWeek = week => {
  return Array(7)
    .fill(0)
    .map((n, i) => {
      return moment()
        .week(week)
        .startOf("week")
        .clone()
        .add(n + i, "day");
    });
};
